import { Component } from '@angular/core';

@Component({
  selector: 'app-coin-config',
  templateUrl: './coin-config.component.html',
  styleUrls: ['./coin-config.component.scss']
})
export class CoinConfigComponent {

}
